module.exports = __webpack_public_path__ + "img/SK.20886a2f.svg";